import { UserModel } from "app/models/user.model";

export class UsertFakeDb {
    public static User: UserModel = {
        defaultTenantId: 1,
        fullUserName: "",
        userName: "",
        permissions: [],
        userId: 1,
        refreshTime: 100,
        roles: []
    }

}
